import { TrackerProgressTile, TrackerProgressTileProps } from "../TrackerProgressTile";

import { ReactComponent as StepsIcon } from "@icons/steps.svg";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";

interface StepsTrackerProgressTileProps {
  inCard?: boolean;
  size?: TrackerProgressTileProps["size"];
}

export const StepsTrackerProgressTile = ({ inCard, size = "lg" }: StepsTrackerProgressTileProps) => {
  const { t } = useTranslation();
  return (
    <TrackerProgressTile
      trackerType={TrackerType.Steps}
      trackerPagePath="steps"
      Icon={StepsIcon}
      caption={t("wellbeing.trackers.steps.caption")}
      wrapInCard={inCard ?? true}
      size={size}
    />
  );
};
